import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Padding } from '../Padding';
import { colorGray } from '@atlas-frontend/design-tokens';

export type ModalFooterProps = PropsWithChildren;

export const ModalFooter: FC<ModalFooterProps> = (props) => (
  <StyledFooter horizontal vertical={10} {...props} />
);

const StyledFooter = styled(Padding)`
  border-top: 1px solid ${colorGray[1]};
`;
